import React from 'react';
import './MyAccountHeader.scss';
import Button from './../Button';
import history from '../../helpers/history';
import c from '../../helpers/constants';
import { setCustomerID, setCustomerPostcode } from '../../helpers/functions';

const MyAccountHeader = () => {
  const onLogout = () => {
    setCustomerID('');
    setCustomerPostcode('');
    history.push(c.APP_ROUTES.LOGIN);
  };
  return (
    <div className="myaccount-header">
      <div className="myaccount-header__title">
        <h3>My Account</h3>
      </div>
      <div className="myaccount-header__logout">
        <Button text="Logout" type="grey" onClick={onLogout} />
      </div>
    </div>
  );
};

export default MyAccountHeader;

